<template>
    <div class="intro-show">
        <div class="title">
            简介管理
            <tip
                name="简介"
                demo-pic="https://lvlin-base.cdn.bcebos.com/bend/intro-demo.png"
                class="tip"
            />
        </div>
        <veui-button
            ui="primary"
            class="modify-btn"
            @click="clickModify"
        >
            修改信息
        </veui-button>
        <div class="content">
            <div class="content-item">
                <div class="label">律所名称</div>
                <div class="value">{{ formData.name }}</div>
            </div>
            <div class="content-item">
                <div class="label">团队名称</div>
                <div class="value">{{ formData.teamName }}</div>
            </div>
            <div class="content-item">
                <div class="label">律所头像</div>
                <div class="value avatar">
                    <img :src="formData.icon"/>
                </div>
            </div>
            <div class="content-item">
                <div class="label">执业许可证</div>
                <div class="value licence">
                    <div class="img" :style="{backgroundImage: `url(${formData.licenceUrl})`}"/>
                </div>
            </div>
            <div class="content-item">
                <div class="label">律所背景</div>
                <div class="value bg">
                    <div
                        v-for="img, index in formData.bgImgs"
                        :key="index"
                        class="img"
                        :style="{backgroundImage: `url(${img})`}"
                    />
                </div>
            </div>
            <div class="content-item">
                <div class="label">律所介绍</div>
                <div class="value">{{ formData.intro }}</div>
            </div>
            <div class="content-item">
                <div class="label">律所成立时间</div>
                <div class="value">{{ formData.setupTime }}</div>
            </div>
            <div class="content-item">
                <div class="label">每周营业时间</div>
                <div class="value">{{ formData.businessWeek }}</div>
            </div>
            <div class="content-item">
                <div class="label">律所地址</div>
                <div class="value">{{ formData.prov }}-{{ formData.city }}-{{ formData.address }}</div>
            </div>
            <div class="content-item">
                <div class="label">律所电话</div>
                <div class="value">{{ formData.tel }}</div>
            </div>
            <div class="content-item">
                <div class="label">擅长领域</div>
                <div class="value">{{ formData.domains }}</div>
            </div>
            <div
                v-for="item in formData.domainInfo"
                :key="item.domain"
                class="content-item"
            >
                <div class="label">{{ item.domain }}描述</div>
                <div class="value">{{ item.desc }}</div>
            </div>
        </div>
    </div>
</template>

<script>
/**
 * @file intro-show.vue
 * @author dingzhenyue
 * @desc 律所简介只读页面
 */
import tip from '@/components/firm/tip';
import dayjs from 'dayjs';
import {
    Button
} from 'veui';

export default {
    name: 'introManagement',
    components: {
        tip,
        'veui-button': Button
    },
    props: {
        firmInfo: {
            'type': Object,
            'default': function () {
                return {};
            }
        }
    },
    data() {
        return {
            // 表单数据
            formData: {}
        };
    },
    watch: {
        firmInfo: {
            handler(val) {
                this.handleGetData(val);
            },
            immediate: true
        }
    },
    methods: {

        /**
         * 处理获取到的数据
         */

        handleGetData(data) {
            this.formData = {
                ...data,
                setupTime: +data.setupTime ? dayjs(data.setupTime * 1000).format('YYYY年MM月DD日') : '',
                bgImgs: data.bgImgs && data.bgImgs.length ? data.bgImgs.split(',') : [],
                domainInfo: data.domainInfo ? JSON.parse(data.domainInfo) : ''
            };
        },

        /**
         * 点击修改按钮
         */

        clickModify() {
            this.$emit('clickModify');
        }
    }
};
</script>

<style lang="less">
    .intro-show {
        background: #fff;
        min-height: 700px;
        font-size: 14px;
        position: relative;

        .modify-btn {
            position: absolute;
            right: 40px;
        }

        .content {
            padding: 0 40px;

            .content-item {
                margin-bottom: 18px;
                display: flex;

                .label {
                    text-align: right;
                    width: 90px;
                }

                .value {
                    margin-left: 20px;

                    img {
                        height: 100%;
                        width: 100%;
                        border: 1px solid #e2e6f0;
                        border-radius: 4px;
                    }

                    &.avatar {
                        height: 80px;
                        width: 80px;
                    }

                    &.licence,
                    &.bg {
                        display: flex;

                        .img {
                            height: 80px;
                            width: 132px;
                            margin-right: 10px;
                            background-repeat: no-repeat;
                            background-position: center center;
                            background-size: contain;
                            border: 1px solid #e2e6f0;
                            box-sizing: content-box;
                        }
                    }
                }
            }
        }
    }
</style>